// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"858":"9adccc91","921":"e779a892","996":"0a333995"}[chunkId] + ".css";
};